import React from 'react';
import clsx from 'clsx';

export const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => {
  return (
    <input
      type={type}
      className={clsx(
        'flex h-10 w-full rounded-[var(--radius-sm)] border border-[var(--muted)] bg-white px-3 py-2 text-sm',
        'placeholder:text-[var(--fg)]/50',
        'focus:outline-none focus:ring-2 focus:ring-[var(--ring)] focus:ring-offset-1',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-shadow duration-200',
        className
      )}
      ref={ref}
      data-testid={props['data-testid'] || 'input'}
      {...props}
    />
  );
});

Input.displayName = 'Input';